/**
 * Сохранённые представления страницы «Элементы».
 *
 * Начальный набор задан спецификацией (документ «Структура интерфейса», §8.4).
 * Пользовательские представления появятся после MVP — сначала нужно увидеть,
 * какими фильтрами команда действительно пользуется.
 */

import { KNOWLEDGE_ITEM_TYPES } from '@project-os/contracts';
import type { ItemQuery } from '@/api/items';

export interface SavedView {
  id: string;
  label: string;
  description: string;
  /** Часть фильтра, задаваемая представлением. Личный фильтр — отдельно. */
  query: ItemQuery;
  /** Представление зависит от текущего пользователя. */
  personal?: boolean;
}

export const SAVED_VIEWS: SavedView[] = [
  {
    id: 'all',
    label: 'Все элементы',
    description: 'Вся проектная информация без фильтра',
    query: {},
  },
  {
    id: 'my-work',
    label: 'Моя работа',
    description: 'Незавершённые элементы, где вы ответственный',
    query: { openOnly: true },
    personal: true,
  },
  {
    id: 'next-actions',
    label: 'Следующие действия',
    description: 'Отмеченные как следующий шаг и ещё не завершённые',
    query: { isNextAction: true, openOnly: true },
  },
  {
    id: 'knowledge',
    label: 'Знания',
    description: 'Заметки, источники, исследования, факты, метрики и гипотезы',
    query: { type: [...KNOWLEDGE_ITEM_TYPES] },
  },
  {
    id: 'open-questions',
    label: 'Открытые вопросы',
    description: 'Вопросы, на которые у проекта пока нет ответа',
    query: { type: ['QUESTION'], status: ['OPEN', 'IN_REVIEW'] },
  },
  {
    id: 'hypotheses',
    label: 'Гипотезы в проверке',
    description: 'Непроверенные и проверяемые предположения',
    query: { type: ['HYPOTHESIS'], status: ['UNTESTED', 'TESTING'] },
  },
  {
    id: 'decisions',
    label: 'Решения',
    description: 'Действующие решения команды',
    query: { type: ['DECISION'], status: ['ACTIVE'], sort: 'createdAt' },
  },
  {
    id: 'risks-blockers',
    label: 'Риски и блокеры',
    description: 'Открытые препятствия и потенциальные проблемы',
    query: { type: ['RISK', 'BLOCKER'], openOnly: true },
  },
];

export function findSavedView(id: string | null): SavedView | undefined {
  return SAVED_VIEWS.find((view) => view.id === id);
}
